import * as React from 'react';

import { useAuth } from '@kp/react-sdk';
import { Colors, createClasses } from '@kp/react-ui';

import { ChatWidget } from '@/components/Chat';
import { Header } from '@/components/Header';
import { HEADER_HEIGHT } from '@/constants/UI';
import { IS_AI_CHAT_ENABLED } from '@/utils/env';

import { Footer } from '../Footer/Footer';

const classes = createClasses({
  bare: {
    padding: '40px 120px 80px',
    minHeight: '100vh',
    borderTop: '1px solid transparent',
    backgroundColor: Colors.Neutral.backgroundHoverStrong,
  },
  content: {
    padding: '40px 120px 80px',
    minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
    marginTop: `${HEADER_HEIGHT}px`,
    borderTop: '1px solid transparent',
    backgroundColor: Colors.Neutral.backgroundHoverStrong,
  },
});

interface PageLayoutProps {
  children?: React.ReactNode;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <div className={classes.bare}>{children}</div>;
  }

  return (
    <div>
      <Header />
      <div className={classes.content}>{children}</div>
      <Footer />
      {IS_AI_CHAT_ENABLED && <ChatWidget />}
    </div>
  );
};
